/* ============================================================================
 * Provador Virtual — controlador de fluxo + engine de recomendação
 * Web component <provador-virtual>. Vanilla JS, sem dependências.
 * Depende de window.ProvadorData (provador-virtual-data.js).
 * ========================================================================== */
(function () {
  'use strict';

  var EPS = 0.001;
  var GAP_TOL = 0.5; // cm: distância máxima p/ recomendar tamanho "aproximado" (acima disso, pede a medida manual)
  var WIDE_EDGE = 0.2; // cm: pé LARGO a menos disso do fim da faixa → sobe um tamanho

  /* ---- helpers ---- */
  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }
  function sizeToken(value) {
    if (value == null) return '';
    var s = String(value);
    var dash = s.indexOf(' - ');
    if (dash >= 0) s = s.slice(0, dash);
    return s.trim();
  }
  function numbersIn(token) {
    var matches = String(token).match(/\d+(?:[.,]\d+)?/g) || [];
    return matches.map(function (m) {
      return parseFloat(m.replace(',', '.'));
    });
  }
  function svgSearch() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
  }
  /* barra de progresso das etapas */
  function progressHTML(mode) {
    if (mode === 'cm') return '';
    var steps = ['brand', 'size', 'fit', 'width'];
    var cur = mode === 'result' ? steps.length : steps.indexOf(mode);
    if (cur < 0) return '';
    var h = '<div class="pv-progress">';
    for (var i = 0; i < steps.length; i++) {
      var cls = i < cur ? 'is-done' : (i === cur ? 'is-active' : '');
      h += '<div class="pv-progress-step ' + cls + '">';
      h += '<div class="pv-progress-dot">' + (i < cur ? '✓' : (i + 1)) + '</div>';
      if (i < steps.length - 1) h += '<div class="pv-progress-line"></div>';
      h += '</div>';
    }
    return h + '</div>';
  }
  function svgShoe() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 17h20a0 0 0 0 1 0 0v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1Z"/><path d="M2 17l1.5-7c.2-1 .9-1.6 1.9-1.4l2.1.4 2.5 2.5 4-2 6 1.5c1.4.4 2 1.3 2 3v3"/></svg>';
  }

  /* Pegada (footprint) vista de cima — ícone "footprint" de Lorc (game-icons.net),
   * licença CC BY 3.0. viewBox nativo 512x512, dedos para cima. */
  var FP =
    'M246.625 18.375c-11.817-.153-23.918 8.608-29.375 22.438-6.716 17.02-.85 35.28 13.094 40.78 13.943 5.502 30.69-3.822 37.406-20.843 6.716-17.02.85-35.28-13.094-40.78-2.614-1.033-5.304-1.56-8.03-1.595zm74.75 15.938c-10.97.006-22.743 6.024-30.78 16.874-12.25 16.534-11.2 38.06 2.342 48.094 13.544 10.035 34.44 4.754 46.688-11.78 12.25-16.534 11.2-38.06-2.344-48.094-4.654-3.45-10.16-5.097-15.905-5.093zm67.25 37.53c-10.336-.127-21.542 4.263-30.47 12.907-15.87 15.368-18.525 38.344-5.936 51.344 12.587 13 35.66 11.086 51.53-4.28 15.87-15.37 18.526-38.345 5.938-51.345-5.508-5.69-13.024-8.527-21.063-8.626zm-156.438 32.063c-22.51-.28-44.378 6.893-63.5 24C107.65 182.513 48.192 261.012 28.28 386.97 5.023 534.1 186.257 507.523 168.313 428.936c-22.922-100.387 34.13-141.11 108-124.156 32.838 7.54 66.54-4.9 86-40.436 23.402-42.733-7.428-106.817-62.875-139.625-21.61-12.79-44.74-20.534-67.25-20.814zM449.438 134c-10.52.022-21.654 2.82-32.093 8.625-27.837 15.48-40.15 46.51-27.47 69.313 12.682 22.802 45.54 28.73 73.376 13.25 27.837-15.48 40.118-46.51 27.438-69.313-7.926-14.252-23.717-21.91-41.25-21.875z';
  function gridBg(id, w, h) {
    return (
      '<defs><pattern id="' + id + '" width="28" height="28" patternUnits="userSpaceOnUse">' +
      '<circle cx="3" cy="3" r="1.6" fill="#ececec"/></pattern></defs>' +
      '<rect x="0" y="0" width="' + w + '" height="' + h + '" fill="url(#' + id + ')"/>'
    );
  }

  /* AJUSTE do comprimento: pegada dentro do "sapato" (pill); folga na ponta varia. */
  function illoFit(fit, imgs) {
    if (imgs && imgs[fit]) {
      return '<img class="pv-illo" decoding="async" src="' + imgs[fit] + '" alt="Ajuste do calçado: ' + fit + '">';
    }
    return illoFitSvg(fit);
  }
  function illoFitSvg(fit) {
    var gap = { justo: 10, na_medida: 70, folgado: 150 };
    var g = gap[fit] != null ? gap[fit] : 70;
    return (
      '<svg class="pv-illo" viewBox="0 0 560 640">' +
      gridBg('pvgf', 560, 640) +
      '<rect x="150" y="20" width="260" height="600" rx="130" fill="#fafbfb" stroke="#c2c6c8" stroke-width="6"/>' +
      '<g transform="translate(152,' + (40 + g) + ') scale(0.5)" fill="#d7dbde"><path d="' + FP + '"/></g>' +
      (g > 30 ? '<line x1="280" y1="34" x2="280" y2="' + (34 + g) + '" stroke="#ba584b" stroke-width="5" stroke-dasharray="9 9"/>' : '') +
      '</svg>'
    );
  }

  /* FORMATO do pé (largura): estreito / médio / largo.
   * Usa imagem real (imgs[width]) se disponível; senão cai no desenho SVG. */
  function illoWidth(width, imgs) {
    if (imgs && imgs[width]) {
      return '<img class="pv-illo" decoding="async" src="' + imgs[width] + '" alt="Formato do pé: ' + width + '">';
    }
    var sx = { estreito: 0.78, medio: 1.0, largo: 1.22 };
    var s = sx[width] != null ? sx[width] : 1.0;
    return (
      '<svg class="pv-illo" viewBox="0 0 512 512">' +
      gridBg('pvgw', 512, 512) +
      '<g transform="matrix(' + s + ',0,0,1,' + (1 - s) * 256 + ',0)" fill="#d7dbde"><path d="' + FP + '"/></g>' +
      '</svg>'
    );
  }

  var STORE_KEY = 'pv_profile_v1';

  /* Tabela do app BestFit (Size Charts by Relentless) lida AO VIVO da página.
   * O app embute em window.sizeChartsRelentless.metafield.chart a tabela já
   * resolvida pro produto atual: values = [["TAMANHO","MEDIDA DO PÉ"],
   * ["34/35","22,6 - 23,5 cm"], ...] (às vezes valor único: "22,5 cm").
   * Editou a tabela no BestFit → o provador acompanha sozinho no próximo load.
   * Retorna { "34/35": [22.6, 23.5], ... } ou null se não houver/for inválida. */
  function bestFitRanges() {
    try {
      var mf = window.sizeChartsRelentless && window.sizeChartsRelentless.metafield;
      var vals = mf && mf.chart && mf.chart.values;
      if (!vals || !vals.length) return null;
      var out = {};
      var n = 0;
      vals.forEach(function (row) {
        if (!row || row.length < 2) return;
        var token = sizeToken(String(row[0]).replace(/&nbsp;/g, ' ').trim());
        if (!token || !/\d/.test(token)) return; // pula header ("TAMANHO", "MEDIDA"...)
        var nums = String(row[1]).replace(/&nbsp;/g, ' ').replace(/,/g, '.').match(/\d+(?:\.\d+)?/g);
        if (!nums || !nums.length) return;
        var lo = parseFloat(nums[0]);
        var hi = parseFloat(nums[1] != null ? nums[1] : nums[0]);
        if (isNaN(lo) || isNaN(hi)) return;
        if (hi < lo) { var t = lo; lo = hi; hi = t; }
        if (lo < 10 || hi > 40) return; // sanity: comprimento de pé em cm
        out[token] = [lo, hi];
        n++;
      });
      return n ? out : null;
    } catch (e) {
      return null;
    }
  }

  /* ===========================================================================
   * ENGINE
   * ========================================================================= */
  var Engine = {
    /* Faixa [min,max] de cm de um tamanho do produto.
     * Usa o metafield se existir; senão deriva da numeração BR. */
    rangeFor: function (token, ranges) {
      // procura no metafield (chaves também são tokenizadas)
      if (ranges) {
        for (var k in ranges) {
          if (Object.prototype.hasOwnProperty.call(ranges, k)) {
            if (sizeToken(k) === token && Array.isArray(ranges[k]) && ranges[k].length === 2) {
              return [Number(ranges[k][0]), Number(ranges[k][1])];
            }
          }
        }
      }
      // fallback: numeração BR -> cm (meio tamanho p/ cada lado)
      var nums = numbersIn(token);
      if (!nums.length) return null;
      var lo = window.ProvadorData.brToFootCm(Math.min.apply(null, nums));
      var hi = window.ProvadorData.brToFootCm(Math.max.apply(null, nums));
      if (lo == null || hi == null) return null;
      return [lo - 0.33, hi + 0.33];
    },

    /* Estima o comprimento do pé (cm) a partir de marca/gênero/tamanho/ajuste. */
    estimateFootCm: function (state) {
      var base = window.ProvadorData.getFootCm(state.brand, state.gender, state.size);
      if (base == null) return null;
      var offset = window.ProvadorData.brandOffsets[state.brand] || 0;
      var fit = window.ProvadorData.fitAdjustCm[state.fit] || 0;
      return Math.round((base + offset + fit) * 10) / 10;
    },

    /* Recomenda o tamanho do produto para um comprimento de pé (cm). */
    recommend: function (footCm, sizes, ranges, width) {
      var list = [];
      sizes.forEach(function (s) {
        var token = sizeToken(s.value);
        var range = Engine.rangeFor(token, ranges);
        if (range) list.push({ value: s.value, token: token, range: range, available: s.available });
      });
      if (!list.length) return null;
      list.sort(function (a, b) {
        return a.range[0] - b.range[0];
      });

      var wsign = window.ProvadorData.widthTieBreak[width] || 0;

      /* alternativa disponível mais próxima (p/ quando o recomendado está esgotado) */
      function nearestAvailable(pick) {
        if (!pick || pick.available !== false) return null;
        var pc = (pick.range[0] + pick.range[1]) / 2;
        var best = null;
        var bd = Infinity;
        list.forEach(function (s) {
          if (s === pick || s.available === false) return;
          var d = Math.abs((s.range[0] + s.range[1]) / 2 - pc);
          if (d < bd) { bd = d; best = s; }
        });
        return best;
      }
      function result(pick, approximate, sizedUp) {
        return { pick: pick, approximate: approximate, footCm: footCm, sizedUp: !!sizedUp, alt: nearestAvailable(pick) };
      }

      // 1) tamanhos cuja faixa contém o comprimento
      var exact = list.filter(function (s) {
        return footCm >= s.range[0] - EPS && footCm <= s.range[1] + EPS;
      });
      if (exact.length) {
        var idx;
        if (wsign > 0) {
          idx = exact.length - 1;
        } else if (wsign < 0) {
          idx = 0;
        } else {
          idx = 0;
          var best = Infinity;
          exact.forEach(function (s, i) {
            var c = (s.range[0] + s.range[1]) / 2;
            var d = Math.abs(footCm - c);
            if (d < best) {
              best = d;
              idx = i;
            }
          });
        }
        var pick = exact[idx];
        // pé LARGO com a medida no fim da faixa → precisa de espaço: sobe um tamanho
        if (wsign > 0 && footCm >= pick.range[1] - WIDE_EDGE) {
          var j = list.indexOf(pick);
          if (j >= 0 && j < list.length - 1) return result(list[j + 1], false, true);
        }
        return result(pick, false);
      }

      // 2) nenhum contém — pega o mais próximo (se dentro da tolerância)
      var nearest = null;
      var nearestDist = Infinity;
      list.forEach(function (s) {
        var d = footCm < s.range[0] ? s.range[0] - footCm : footCm > s.range[1] ? footCm - s.range[1] : 0;
        if (d < nearestDist) {
          nearestDist = d;
          nearest = s;
        }
      });
      if (nearest && nearestDist <= GAP_TOL) {
        return result(nearest, true);
      }
      return null; // sem tamanho compatível
    }
  };

  /* ===========================================================================
   * COMPONENTE
   * ========================================================================= */
  if (customElements.get('provador-virtual')) return;

  customElements.define(
    'provador-virtual',
    class ProvadorVirtual extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        var cfgEl = this.querySelector('script[type="application/json"]');
        try {
          this.config = JSON.parse(cfgEl.textContent);
        } catch (e) {
          this.config = { sizes: [], ranges: {} };
        }
        this.config.sizes = this.config.sizes || [];
        this.config.ranges = this.config.ranges || {};
        // textos/marcas/imagens editáveis nas Configurações do tema (grupo 👟);
        // t() devolve o texto da setting ou o padrão do código
        this.ui = this.config.ui || {};

        this.trigger = this.querySelector('.pv-trigger');
        if (this.trigger) this.trigger.addEventListener('click', this.open.bind(this));
        this.refreshTriggerLabel();
      }

      resetState() {
        this.state = { mode: 'brand', gender: 'feminino', brand: null, size: null, fit: null, width: null, cm: null };
      }

      /* faixas de cm do produto: metafield > tabela do BestFit (ao vivo) > tabela por handle > fallback BR */
      getRanges() {
        var r = this.config.ranges;
        if (r && Object.keys(r).length) return r;
        var bf = bestFitRanges();
        if (bf) return bf;
        var overrides = (window.ProvadorData && window.ProvadorData.productRanges) || {};
        return overrides[this.config.handle] || {};
      }

      /* ---- persistência do perfil (localStorage) ---- */
      loadProfile() {
        try {
          var raw = window.localStorage.getItem(STORE_KEY);
          return raw ? JSON.parse(raw) : null;
        } catch (e) {
          return null;
        }
      }
      saveProfile() {
        try {
          var s = this.state;
          window.localStorage.setItem(
            STORE_KEY,
            JSON.stringify({ mode: s.mode, gender: s.gender, brand: s.brand, size: s.size, fit: s.fit, width: s.width, cm: s.cm })
          );
        } catch (e) {}
        this.refreshTriggerLabel();
      }
      clearProfile() {
        try {
          window.localStorage.removeItem(STORE_KEY);
        } catch (e) {}
        this.refreshTriggerLabel();
      }
      /* mostra o tamanho recomendado no próprio botão, se já houver perfil */
      refreshTriggerLabel() {
        if (!this.trigger) return;
        var p = this.loadProfile();
        // layout 2 chips usa .pv-chip__label; .pv-trigger-label é o pill antigo
        var labelEl = this.trigger.querySelector('.pv-chip__label') || this.trigger.querySelector('.pv-trigger-label');
        if (!labelEl) return;
        if (!labelEl.dataset.pvDefault) labelEl.dataset.pvDefault = labelEl.textContent;
        var footCm = p ? (p.mode === 'manual' ? p.cm : Engine.estimateFootCm(p)) : null;
        var rec = footCm != null ? Engine.recommend(footCm, this.config.sizes, this.getRanges(), p.width) : null;
        labelEl.textContent = rec ? 'Seu tamanho: ' + rec.pick.token + ' · refazer' : labelEl.dataset.pvDefault;
      }

      /* ---- abas (Provador | Tabela de medidas) ---- */
      bindTabs() {
        var self = this;
        var tabs = this.overlay.querySelectorAll('[data-pv-tab]');
        if (!tabs.length) return;
        tabs.forEach(function (btn) {
          btn.addEventListener('click', function () { self.showTab(btn.getAttribute('data-pv-tab')); });
        });
        this.overlay.addEventListener('click', function (e) {
          if (e.target && e.target.classList && e.target.classList.contains('pv-guide__native')) self.abrirTabelaNativa();
        });
      }

      showTab(qual) {
        if (!this.overlay) return;
        var body = this.overlay.querySelector('.pv-body');
        var slot = this.overlay.querySelector('.pv-progress-slot');
        var guide = this.overlay.querySelector('.pv-guide');
        var aside = this.overlay.querySelector('.pv-aside');
        this.overlay.querySelectorAll('[data-pv-tab]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-pv-tab') === qual);
        });
        var naTabela = qual === 'guide';
        if (body) body.hidden = naTabela;
        if (slot) slot.hidden = naTabela;
        if (guide) {
          guide.hidden = !naTabela;
          if (naTabela && !guide.dataset.pronta) { guide.innerHTML = this.renderGuide(); guide.dataset.pronta = '1'; }
        }
        if (aside) aside.classList.toggle('pv-aside--dim', naTabela);
      }

      /* tabela de medidas montada a partir da MESMA fonte do provador (app BestFit),
         então editar lá continua refletindo aqui sem tocar no tema */
      renderGuide() {
        var como = this.config.imgGuide
          ? '<img class="pv-guide__como" src="' + this.config.imgGuide + '" alt="Como tirar suas medidas: meça do calcanhar à ponta do dedão, descalço, com o calcanhar encostado na parede" width="660" height="1106" decoding="async">'
          : '';
        var vals = null;
        try {
          var mf = window.sizeChartsRelentless && window.sizeChartsRelentless.metafield;
          vals = mf && mf.chart && mf.chart.values;
        } catch (e) {}
        if (!vals || !vals.length) {
          return como + '<p class="pv-guide__empty">A tabela de medidas deste produto não está disponível aqui. ' +
                 '<button type="button" class="pv-guide__native">Abrir tabela completa</button></p>';
        }
        var html = como + '<table class="pv-guide__table"><tbody>';
        vals.forEach(function (row, i) {
          if (!row || !row.length) return;
          var tag = i === 0 ? 'th' : 'td';
          html += '<tr>';
          row.forEach(function (cel) {
            html += '<' + tag + '>' + String(cel == null ? '' : cel).replace(/&nbsp;/g, ' ') + '</' + tag + '>';
          });
          html += '</tr>';
        });
        html += '</tbody></table>';
        if (!como) html += '<p class="pv-guide__nota">Meça o pé descalço, do calcanhar à ponta do dedo maior.</p>';
        return html;
      }

      /* As ilustrações só entravam no DOM no passo em que aparecem, então a 1ª
         exibição esperava o download (medido: ~170-800ms). Ao abrir o modal já
         busca as 6 em segundo plano — quando o cliente chega no passo, vêm do cache. */
      preloadIllos() {
        if (this._preloaded) return;
        this._preloaded = true;
        var urls = [].concat(
          Object.values(this.config.imgWidth || {}),
          Object.values(this.config.imgFit || {})
        );
        urls.forEach(function (u) { if (u) { var i = new Image(); i.decoding = 'async'; i.src = u; } });
      }

      open() {
        if (!this.overlay) { this.buildOverlay(); this.bindTabs(); }
        this.preloadIllos();
        var p = this.loadProfile();
        if (p && (p.size != null || p.cm != null)) {
          this.state = { mode: p.mode || 'brand', gender: p.gender || 'feminino', brand: p.brand || null, size: p.size != null ? p.size : null, fit: p.fit || null, width: p.width || null, cm: p.cm != null ? p.cm : null };
        } else {
          this.resetState();
        }
        this.overlay.classList.add('is-open');
        document.body.classList.add('pv-no-scroll');
        this.go(p && (p.size != null || p.cm != null) ? 'result' : 'brand');
        if (this.overlay.querySelector('[data-pv-tab]')) this.showTab('fitter');
      }

      abrirTabelaNativa() {
        var a = document.querySelector('.best-fit-size-chart .scr-open-size-chart') || document.querySelector('.scr-open-size-chart');
        if (a) { this.close(); a.click(); }
      }

      close() {
        if (this.overlay) this.overlay.classList.remove('is-open');
        document.body.classList.remove('pv-no-scroll');
      }

      buildOverlay() {
        var c = this.config;
        var img = c.image
          ? '<img src="' + c.image + '" alt="' + (c.title || '') + '">'
          : '';
        this.overlay = el(
          '<div class="pv-overlay" role="dialog" aria-modal="true">' +
            '<div class="pv-modal">' +
            '<div class="pv-handle" aria-hidden="true"></div>' +
            '<button class="pv-close" type="button" aria-label="Fechar">&times;</button>' +
            '<div class="pv-aside">' +
            img +
            '<div class="pv-aside-kicker">' + this.t('asideKicker', 'Provador Virtual') + '</div>' +
            '<div class="pv-aside-title">' + this.t('asideTitle', 'Descubra seu tamanho ideal') + '</div>' +
            '<p class="pv-aside-text">' + this.t('asideText', 'Responda 4 passos rápidos e a gente indica o número certo pra você — sem erro na hora da compra.') + '</p>' +
            '</div>' +
            '<div class="pv-main">' +
              (this.config.showGuideTab
                ? '<div class="pv-tabs" role="tablist">' +
                    '<button type="button" class="pv-tab is-active" data-pv-tab="fitter" role="tab">' + this.t('tabFitter', 'Provador virtual') + '</button>' +
                    '<button type="button" class="pv-tab" data-pv-tab="guide" role="tab">' + this.t('tabGuide', 'Tabela de medidas') + '</button>' +
                  '</div>'
                : '') +
              '<div class="pv-progress-slot"></div><div class="pv-body"></div><div class="pv-guide" hidden></div>' +
            '</div>' +
            '</div>' +
            '</div>'
        );
        document.body.appendChild(this.overlay);
        this.body = this.overlay.querySelector('.pv-body');
        this.overlay.querySelector('.pv-close').addEventListener('click', this.close.bind(this));
        this.overlay.addEventListener('click', function (e) {
          if (e.target === this.overlay) this.close();
        }.bind(this));
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') this.close();
        }.bind(this));
      }

      /* roteador de passos */
      go(step) {
        this.step = step;
        var map = {
          brand: this.renderBrand,
          size: this.renderSize,
          fit: this.renderFit,
          width: this.renderWidth,
          cm: this.renderCm,
          result: this.renderResult
        };
        (map[step] || this.renderBrand).call(this);
        var slot = this.overlay.querySelector('.pv-progress-slot');
        if (slot) slot.innerHTML = progressHTML(step);
        // re-dispara o fade do conteúdo
        if (this.body) { this.body.style.animation = 'none'; void this.body.offsetWidth; this.body.style.animation = ''; }
        this.overlay.querySelector('.pv-main').scrollTop = 0;
      }

      footer(opts) {
        // opts: { back, next, nextLabel, nextDisabled, backLabel }
        var html = '<div class="pv-footer">';
        if (opts.back) html += '<button class="pv-btn pv-btn-secondary" data-act="back">' + (opts.backLabel || 'Voltar') + '</button>';
        if (opts.next) html += '<button class="pv-btn pv-btn-primary" data-act="next"' + (opts.nextDisabled ? ' disabled' : '') + '>' + (opts.nextLabel || 'Próximo') + '</button>';
        return html + '</div>';
      }

      /* ---- Passo 1: marca ---- */
      renderBrand() {
        var data = window.ProvadorData;
        // marcas em destaque: setting do tema (lista por vírgula, na ordem) > flag popular do data.js
        var popular = null;
        var setting = String(this.t('brands', '')).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        if (setting.length) {
          popular = setting.map(function (name) {
            var known = data.brands.find(function (b) { return b.name.toLowerCase() === name.toLowerCase(); });
            return known || { name: name }; // desconhecida ainda funciona (curva padrão)
          });
        }
        if (!popular || !popular.length) popular = data.brands.filter(function (b) { return b.popular; });
        var html = '<h3 class="pv-title">' + this.t('qBrand', 'Qual marca você costuma usar?') + '</h3>';
        html += '<div class="pv-search">' + svgSearch() + '<input type="text" placeholder="Digite e pesquise sua marca aqui" autocomplete="off"></div>';
        html += '<div class="pv-brand-list" hidden></div>';
        html += '<div class="pv-brand-grid">';
        popular.forEach(function (b) {
          html += '<button class="pv-brand" data-brand="' + b.name + '">' + b.name + '</button>';
        });
        html += '</div>';
        html += '<button class="pv-link-btn" data-act="manual">Já sei a medida do meu pé</button>';
        html += this.footer({ next: true, nextDisabled: !this.state.brand });
        this.body.innerHTML = html;

        var self = this;
        var input = this.body.querySelector('.pv-search input');
        var listEl = this.body.querySelector('.pv-brand-list');
        var grid = this.body.querySelector('.pv-brand-grid');

        function markSelected() {
          self.body.querySelectorAll('.pv-brand').forEach(function (btn) {
            btn.classList.toggle('is-selected', btn.dataset.brand === self.state.brand);
          });
          var nextBtn = self.body.querySelector('[data-act="next"]');
          if (nextBtn) nextBtn.disabled = !self.state.brand;
        }
        function pick(name) {
          self.state.brand = name;
          self.state.mode = 'brand';
          markSelected();
        }

        grid.addEventListener('click', function (e) {
          var btn = e.target.closest('.pv-brand');
          if (btn) pick(btn.dataset.brand);
        });

        function renderList(query) {
          var q = (query || '').trim().toLowerCase();
          var matches = q
            ? data.brands.filter(function (b) { return b.name.toLowerCase().indexOf(q) !== -1; })
            : data.brands.slice();
          grid.style.display = 'none';
          listEl.innerHTML = matches.length
            ? matches.map(function (b) {
                return '<button data-brand="' + b.name + '"' + (b.name === self.state.brand ? ' class="is-selected"' : '') + '>' + b.name + '</button>';
              }).join('')
            : '<button disabled style="color:#999">Marca não encontrada — use "Já sei a medida do meu pé"</button>';
          listEl.hidden = false;
        }
        // mostra a lista completa ao clicar/focar no campo de busca
        input.addEventListener('focus', function () { renderList(input.value); });
        input.addEventListener('input', function () { renderList(input.value); });
        listEl.addEventListener('click', function (e) {
          var btn = e.target.closest('button[data-brand]');
          if (btn) {
            pick(btn.dataset.brand);
            input.value = btn.dataset.brand;
            listEl.hidden = true;
            grid.style.display = '';
          }
        });

        markSelected();
        this.wireFooter({
          manual: function () {
            self.state.mode = 'manual';
            self.go('cm');
          },
          next: function () {
            if (self.state.brand) self.go('size');
          }
        });
      }

      /* ---- Passo 2: tamanho ---- */
      renderSize() {
        var data = window.ProvadorData;
        var self = this;
        // Grade vem da TABELA da marca (só tamanhos reais → sem extrapolar).
        // Marca sem tabela oficial usa a grade padrão.
        var grid;
        var ck = data.brandCharts[this.state.brand];
        if (ck && data.charts[ck] && data.charts[ck][this.state.gender]) {
          grid = Object.keys(data.charts[ck][this.state.gender]).map(Number).sort(function (a, b) { return a - b; });
        } else {
          grid = data.sizeGrid[this.state.gender] || data.sizeGrid.feminino;
        }
        var html = '<h3 class="pv-title">' + this.t('qSize', 'Qual é o tamanho do seu calçado?') + '</h3>';
        html += '<p class="pv-subtitle">Escolha seu tamanho na <strong>' + this.state.brand + '</strong></p>';
        html += '<div class="pv-region">🇧🇷 Região: BR</div>';
        html += '<div class="pv-tabs">' +
          '<button class="pv-tab' + (this.state.gender === 'feminino' ? ' is-active' : '') + '" data-gender="feminino">Feminino</button>' +
          '<button class="pv-tab' + (this.state.gender === 'masculino' ? ' is-active' : '') + '" data-gender="masculino">Masculino</button>' +
          '</div>';
        html += '<div class="pv-size-grid">';
        grid.forEach(function (s) {
          var label = Number.isInteger(s) ? s : String(s).replace('.', ',');
          html += '<button class="pv-size' + (self.state.size === s ? ' is-selected' : '') + '" data-size="' + s + '">' + label + '</button>';
        });
        html += '</div>';
        html += this.footer({ back: true, next: true, nextDisabled: this.state.size == null });
        this.body.innerHTML = html;

        this.body.querySelector('.pv-tabs').addEventListener('click', function (e) {
          var t = e.target.closest('.pv-tab');
          if (t) {
            self.state.gender = t.dataset.gender;
            self.state.size = null;
            self.go('size');
          }
        });
        this.body.querySelector('.pv-size-grid').addEventListener('click', function (e) {
          var b = e.target.closest('.pv-size');
          if (!b) return;
          self.state.size = parseFloat(b.dataset.size);
          self.body.querySelectorAll('.pv-size').forEach(function (x) { x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          var nb = self.body.querySelector('[data-act="next"]');
          if (nb) nb.disabled = false;
        });
        this.wireFooter({
          back: function () { self.go('brand'); },
          next: function () { if (self.state.size != null) self.go('fit'); }
        });
      }

      /* ---- Passo 3: ajuste do comprimento ---- */
      renderFit() {
        var self = this;
        if (!this.state.fit) this.state.fit = 'na_medida';
        var opts = [
          { v: 'justo', label: 'Justo' },
          { v: 'na_medida', label: 'Na Medida' },
          { v: 'folgado', label: 'Folgado' }
        ];
        var html = '<h3 class="pv-title">' + this.t('qFit', 'Como é o ajuste do comprimento do seu calçado?') + '</h3>';
        html += '<p class="pv-subtitle">Calce o seu <strong>' + this.state.brand + '</strong> tamanho <strong>' + this.fmtSize() + '</strong> e nos diga como o comprimento se ajusta ao seu pé.</p>';
        var imgsF = this.config.imgFit;
        html += '<div class="pv-illo-wrap">' + illoFit(this.state.fit || 'na_medida', imgsF) + '</div>';
        html += this.optionList(opts, this.state.fit);
        html += '<p class="pv-option-hint">Pense no espaço entre o seu dedo maior e a ponta do calçado.</p>';
        html += this.footer({ back: true, next: true, nextDisabled: !this.state.fit });
        this.body.innerHTML = html;
        var illoF = this.body.querySelector('.pv-illo-wrap');
        this.wireOptions(function (v) { self.state.fit = v; if (illoF) illoF.innerHTML = illoFit(v, imgsF); });
        this.wireFooter({
          back: function () { self.go('size'); },
          next: function () { if (self.state.fit) self.go('width'); }
        });
      }

      /* ---- Passo 4: formato do pé ---- */
      renderWidth() {
        var self = this;
        if (!this.state.width) this.state.width = 'medio';
        var opts = [
          { v: 'estreito', label: 'Estreito' },
          { v: 'medio', label: 'Médio' },
          { v: 'largo', label: 'Largo' }
        ];
        var html = '<h3 class="pv-title">' + this.t('qWidth', 'Qual é o formato do seu pé?') + '</h3>';
        html += '<p class="pv-subtitle">Selecione a largura do seu pé para melhorar o ajuste.</p>';
        var imgs = this.config.imgWidth;
        html += '<div class="pv-illo-wrap">' + illoWidth(this.state.width || 'medio', imgs) + '</div>';
        html += this.optionList(opts, this.state.width);
        html += '<p class="pv-option-hint">Pés médios se ajustam bem em quase todos os calçados.</p>';
        html += this.footer({ back: true, next: true, nextLabel: 'Ver meu tamanho', nextDisabled: !this.state.width });
        this.body.innerHTML = html;
        var illoW = this.body.querySelector('.pv-illo-wrap');
        this.wireOptions(function (v) { self.state.width = v; if (illoW) illoW.innerHTML = illoWidth(v, imgs); });
        this.wireFooter({
          back: function () { self.go('fit'); },
          next: function () { if (self.state.width) self.go('result'); }
        });
      }

      /* ---- Passo alternativo: medida em cm ---- */
      renderCm() {
        var self = this;
        var val = this.state.cm || 25;
        var html = '<h3 class="pv-title">Qual é a medida do seu pé?</h3>';
        html += '<p class="pv-subtitle">Meça do calcanhar até a ponta do dedo maior.</p>';
        html += '<div class="pv-cm">';
        html += '<div class="pv-cm-field"><input type="number" step="0.1" min="15" max="35" value="' + val + '"><span>cm</span></div>';
        html += '<input type="range" min="18" max="33" step="0.1" value="' + val + '">';
        html += '</div>';
        html += this.footer({ back: true, next: true, nextLabel: 'Ver meu tamanho' });
        this.body.innerHTML = html;

        var num = this.body.querySelector('input[type="number"]');
        var range = this.body.querySelector('input[type="range"]');
        num.addEventListener('input', function () { range.value = num.value; });
        range.addEventListener('input', function () { num.value = range.value; });
        this.wireFooter({
          back: function () { self.go('brand'); },
          next: function () {
            self.state.cm = parseFloat(num.value);
            self.go('result');
          }
        });
      }

      /* ---- Resultado ---- */
      renderResult() {
        var self = this;
        var footCm = this.state.mode === 'manual' ? this.state.cm : Engine.estimateFootCm(this.state);
        var rec = footCm != null ? Engine.recommend(footCm, this.config.sizes, this.getRanges(), this.state.width) : null;
        this.saveProfile();

        var html = '<div class="pv-result">';
        if (rec) {
          var p = rec.pick;
          html += '<div class="pv-result-card">';
          html += '<div class="pv-result-badge">' + this.t('resultBadge', 'Seu tamanho ideal') + '</div>';
          html += '<div class="pv-result-size">' + p.token + '</div>';
          html += '<div class="pv-result-conf"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>' + (rec.approximate ? 'Boa estimativa' : 'Alta confiança') + '</div>';
          html += '<div class="pv-result-foot">Comprimento estimado do pé: <strong>' + footCm.toFixed(1).replace('.', ',') + ' cm</strong></div>';
          html += '</div>';
          var note = '';
          if (rec.approximate) note += 'Não há um tamanho exato — este é o mais próximo do seu pé. ';
          if (rec.sizedUp) {
            note += 'Sua medida ficava no limite do tamanho anterior e, como seu pé é mais largo, indicamos um tamanho acima para garantir o conforto. ';
          } else {
            if (this.state.width === 'largo') note += 'Como seu pé é mais largo, em caso de dúvida prefira o tamanho maior. ';
            if (this.state.width === 'estreito') note += 'Como seu pé é mais estreito, em caso de dúvida prefira o tamanho menor. ';
          }
          if (p.available === false) {
            note += 'Atenção: este tamanho está esgotado no momento. ';
            if (rec.alt) note += 'O tamanho ' + rec.alt.token + ' está disponível e é o mais próximo do seu pé. ';
          }
          if (note) html += '<div class="pv-result-note">' + note.trim() + '</div>';
          html += this.footer({ back: true, next: true, nextLabel: this.t('cta', 'Selecionar este tamanho'), backLabel: 'Refazer' });
        } else {
          html += '<div class="pv-result-badge">Não encontramos um tamanho ideal</div>';
          html += '<p class="pv-result-empty">Não temos um tamanho que corresponda exatamente à medida informada' + (footCm != null ? ' (' + footCm.toFixed(1).replace('.', ',') + ' cm)' : '') + '. Ajuste a medida abaixo se necessário.</p>';
          var v = footCm != null ? footCm.toFixed(1) : 25;
          html += '<div class="pv-cm"><div class="pv-cm-field"><input type="number" step="0.1" min="15" max="35" value="' + v + '"><span>cm</span></div>';
          html += '<input type="range" min="18" max="33" step="0.1" value="' + v + '"></div>';
          html += this.footer({ back: true, next: true, nextLabel: 'Calcular novamente', backLabel: 'Refazer' });
        }
        html += '<button class="pv-result-redo" data-act="redo">Começar de novo (novo perfil)</button>';
        html += '</div>';
        this.body.innerHTML = html;

        // estado "não encontrou": recalcula com cm manual
        var num = this.body.querySelector('input[type="number"]');
        if (num) {
          var range = this.body.querySelector('input[type="range"]');
          num.addEventListener('input', function () { range.value = num.value; });
          range.addEventListener('input', function () { num.value = range.value; });
        }

        this.wireFooter({
          back: function () {
            self.go(self.state.mode === 'manual' ? 'cm' : 'brand');
          },
          next: function () {
            if (rec) {
              self.applySize(rec.pick);
            } else if (num) {
              self.state.mode = 'manual';
              self.state.cm = parseFloat(num.value);
              self.go('result');
            }
          },
          redo: function () {
            self.clearProfile();
            self.resetState();
            self.go('brand');
          }
        });
      }

      /* ---- seleciona o tamanho real no seletor de variantes do tema ---- */
      applySize(pick) {
        var name = (this.config.optionName || 'Tamanho').toLowerCase();
        var radios = document.querySelectorAll('input[type="radio"]');
        var target = null;
        radios.forEach(function (r) {
          if (target) return;
          if ((r.name || '').toLowerCase() !== name) return;
          if (sizeToken(r.value) === pick.token) target = r;
        });
        if (target) {
          target.checked = true;
          target.click();
          target.dispatchEvent(new Event('change', { bubbles: true }));
          var picker = target.closest('.product-form__input') || target.closest('variant-radios');
          if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        this.close();
      }

      /* ---- utilidades de UI ---- */
      t(key, fallback) {
        var v = this.ui && this.ui[key];
        return (v != null && String(v).trim() !== '') ? v : fallback;
      }
      optionList(opts, selected) {
        var html = '<div class="pv-options">';
        opts.forEach(function (o) {
          html += '<button class="pv-option' + (selected === o.v ? ' is-selected' : '') + '" data-val="' + o.v + '"><span class="pv-radio"></span>' + o.label + '</button>';
        });
        return html + '</div>';
      }
      wireOptions(onPick) {
        var self = this;
        this.body.querySelector('.pv-options').addEventListener('click', function (e) {
          var b = e.target.closest('.pv-option');
          if (!b) return;
          onPick(b.dataset.val);
          self.body.querySelectorAll('.pv-option').forEach(function (x) { x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          var nb = self.body.querySelector('[data-act="next"]');
          if (nb) nb.disabled = false;
        });
      }
      wireFooter(handlers) {
        var self = this;
        ['back', 'next', 'manual', 'redo'].forEach(function (act) {
          var btn = self.body.querySelector('[data-act="' + act + '"]');
          if (btn && handlers[act]) btn.addEventListener('click', handlers[act]);
        });
      }
      fmtSize() {
        var s = this.state.size;
        return Number.isInteger(s) ? s : String(s).replace('.', ',');
      }
    }
  );
})();
